import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { MapPin, Activity } from 'lucide-react';
import { activities } from '../data/mockData';

const ActivitiesSection = () => {
  return (
    <section id="activites" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <Badge variant="secondary" className="px-4 py-2 text-sm font-medium bg-emerald-100 text-emerald-800 border-emerald-200 mb-4">
              <Activity className="h-4 w-4 mr-2" />
              Découvrir les environs
            </Badge>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Activités & 
              <span className="bg-gradient-to-r from-emerald-600 to-emerald-600 bg-clip-text text-transparent"> Loisirs</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Profitez de votre séjour pour découvrir les nombreuses activités et attractions que notre région thermale a à offrir.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {activities.map((activity, index) => (
              <Card key={index} className="group hover:shadow-2xl transition-all duration-300 border-gray-200 hover:border-emerald-200 overflow-hidden">
                <CardContent className="p-0">
                  <div className="relative overflow-hidden">
                    <img 
                      src={activity.image}
                      alt={activity.title}
                      className="w-full h-48 object-cover transition-transform duration-300 group-hover:scale-110"
                    />
                    <div className="absolute top-4 right-4">
                      <Badge className="bg-white/90 text-emerald-600 border-emerald-200">
                        <MapPin className="h-3 w-3 mr-1" />
                        {activity.distance}
                      </Badge>
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                  
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-emerald-600 transition-colors duration-300">
                      {activity.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {activity.description}
                    </p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="mt-16 bg-gradient-to-r from-emerald-50 to-emerald-50 rounded-2xl p-8 border border-emerald-100">
            <div className="text-center">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Besoin de conseils personnalisés ?</h3>
              <p className="text-gray-700 mb-6">
                Notre équipe connaît parfaitement la région et sera ravie de vous conseiller sur les meilleures activités selon vos goûts et la saison.
              </p>
              <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-600">
                <div className="flex items-center space-x-1">
                  <div className="w-2 h-2 bg-emerald-600 rounded-full"></div>
                  <span>Informations touristiques</span>
                </div>
                <div className="flex items-center space-x-1">
                  <div className="w-2 h-2 bg-emerald-600 rounded-full"></div>
                  <span>Réservations activités</span>
                </div>
                <div className="flex items-center space-x-1">
                  <div className="w-2 h-2 bg-emerald-600 rounded-full"></div>
                  <span>Conseils personnalisés</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ActivitiesSection;